// Aperçu personnalisé du lien (une seule saisie) : la donnée reste formDataNetwork.linkedin.snippet
// { customActived, title, image: { id } } (envoyée en data.snippetTitle / data.snippet aux pages LinkedIn,
// comme avant), plus `description`. Avec la beta url_shortener, la même saisie est envoyée en plus à
// toutes les pages en data.short_link_og { title, description, image } (aperçu du lien court mws.li).
import { hasBetaFeature } from '@/utils/betaFeatures'

export function linkPreviewUnified() {
    return hasBetaFeature('url_shortener')
}

// short_link_og d'un post (racine de la news ES, ou recopié sur page[0] par GET /posts/get), objet ou chaîne JSON ;
// null si absent ou sans titre ni image
export function shortLinkOgOf(post) {
    if (!post) return null
    const page = Array.isArray(post.page) ? post.page[0] : null
    let og = post.short_link_og || (page && page.short_link_og) || null
    if (typeof og === 'string') {
        try { og = JSON.parse(og) } catch (e) { og = null }
    }
    return og && typeof og === 'object' && (og.title || og.image) ? og : null
}

// short_link_og d'une page de post (objet ou chaîne JSON), sinon snippet_title / snippet historiques
export function linkPreviewFromPost(postPage) {
    if (!postPage) return null

    let og = postPage.short_link_og
    if (typeof og === 'string') {
        try { og = JSON.parse(og) } catch (e) { og = null }
    }
    if (og && (og.title || og.image)) {
        return { title: og.title || '', description: og.description || '', imageUrl: og.image || null }
    }

    if (postPage.snippet_title || (typeof postPage.snippet === 'string' && postPage.snippet.startsWith('http'))) {
        return {
            title: postPage.snippet_title || '',
            description: '',
            imageUrl: typeof postPage.snippet === 'string' && postPage.snippet.startsWith('http') ? postPage.snippet : null
        }
    }
    return null
}

// Aperçu de la saisie en cours pour les cartes de lien hors LinkedIn (RenderPostManager linkPreviewOverride) :
// LinkedIn lit déjà snippet.customActived, les autres réseaux n'avaient l'aperçu qu'une fois le post publié (drawer).
// Champs vides => ceux du site sont gardés par RenderPostManager ; image affichée dès sa sélection (blob local).
export function liveLinkPreviewOverride(snippet, files) {
    if (!linkPreviewUnified() || !snippet || !snippet.customActived) return null
    const file = snippet.image && snippet.image.id ? files[snippet.image.id] : null
    const og = {
        title: (snippet.title || '').trim(),
        description: (snippet.description || '').trim(),
        image: (file && file.url) || ''
    }
    return og.title || og.description || og.image ? og : null
}

// Aperçu d'origine d'une URL depuis la réponse de GET /posts/meta (mêmes champs que SnippetNetwork.vue), sinon null
export function originalPreviewFromMeta(body) {
    if (!body || body.success !== true || !body.meta) return null
    const { meta } = body
    const og = meta.og || {}
    const tags = meta.meta || {}
    return {
        title: og.title || tags.title || '',
        description: og.description || tags.description || '',
        imageUrl: og.image || (meta.image && meta.image[0] && meta.image[0].url) || (meta.images && meta.images[0] && meta.images[0].url) || null
    }
}

// Fichier depuis la data URI renvoyée par GET /posts/image (image distante lue côté engine : pas de CORS)
export async function fileFromDataUri(dataUri, name = 'link-preview') {
    if (typeof dataUri !== 'string' || !dataUri.startsWith('data:image/')) return null
    const blob = await (await fetch(dataUri)).blob()
    const ext = (blob.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg').replace(/[^a-z0-9]/gi, '')
    return new File([blob], `${name}.${ext}`, { type: blob.type })
}

// Valeur de data.short_link_og pour une page, ou null (saisie incomplète : titre et image envoyée requis)
// url : lien auquel s'applique l'aperçu (lien d'aperçu, sinon 1re URL du texte), pour les réseaux où le lien n'est que
// dans le texte (ex. Twitter) ; la Lambda de publication retombe sur la 1re URL du texte s'il n'y figure pas
export function buildShortLinkOg(snippet, files, link = null) {
    if (!snippet || !snippet.customActived) return null
    const title = (snippet.title || '').trim()
    const image = snippet.image && snippet.image.id ? files[snippet.image.id] : null
    if (!title || !image || !image.isUpload || !image.url) return null
    const url = (snippet.link || link || '').trim()
    return JSON.stringify({
        title,
        description: (snippet.description || '').trim(),
        image: image.url,
        ...(url ? { url } : {})
    })
}
